var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { on: { change: _vm.logChangeData } }, [
    _c("div", { staticClass: "setting_content" }, [
      _c("div", { staticClass: "setting_content_main" }, [
        _c("h2", { staticClass: "setting_content_title" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.labelsProperties.TAB_HEADER) + "\n      "
          )
        ]),
        _c("p", { staticClass: "setting_unit_annotation" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.labelsProperties.SELECT_OPTION_ANNOTATION) +
              "\n      "
          )
        ]),
        _vm.hp_renkei_job === 1
          ? _c("div", { staticClass: "setting_unit" }, [
              _c("p", { staticClass: "setting_unit_title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.labelsProperties.PROGRESS_SETTING) +
                    "\n        "
                )
              ]),
              _c("p", { staticClass: "setting_unit_explain" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.labelsProperties.PROGRESS_SETTING_EXPLAIN) +
                    "\n        "
                )
              ]),
              _c("div", { staticClass: "setting_unit_item" }, [
                _c("p", { staticClass: "setting_unit_label" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.labelsProperties.PROGRESS_STEP) +
                      "\n          "
                  )
                ]),
                _c("div", { staticClass: "setting_unit_form" }, [
                  _c("div", { staticClass: "setting_form_select_wrapper" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.displaySetting.progressStep,
                            expression: "displaySetting.progressStep"
                          }
                        ],
                        staticClass: "setting_form_select",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.displaySetting,
                              "progressStep",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(
                        _vm.masterStepStates.filter(function(stepState) {
                          return stepState && stepState.show
                        }),
                        function(stepState, index) {
                          return _c("option", {
                            key: index,
                            domProps: {
                              value: stepState.choiceId,
                              textContent: _vm._s(
                                stepState.choiceDisplayName
                                  ? stepState.choiceDisplayName
                                  : stepState.choiceName
                              )
                            }
                          })
                        }
                      ),
                      0
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "setting_unit_item" }, [
                _c("p", { staticClass: "setting_unit_label" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.labelsProperties.MANAGER) +
                      "\n          "
                  )
                ]),
                _c("div", { staticClass: "setting_unit_form" }, [
                  _c("div", { staticClass: "setting_form_select_wrapper" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.displaySetting.manager,
                            expression: "displaySetting.manager"
                          }
                        ],
                        staticClass: "setting_form_select",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.displaySetting,
                              "manager",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(
                        _vm.users.filter(function(user) {
                          return user && user.display_name
                        }),
                        function(user, index) {
                          return _c("option", {
                            key: index,
                            domProps: {
                              value: user.id,
                              textContent: _vm._s(user.display_name)
                            }
                          })
                        }
                      ),
                      0
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm.hp_renkei_entry === 1
          ? _c("div", { staticClass: "setting_unit" }, [
              _c("p", { staticClass: "setting_unit_title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.labelsProperties.OTHER_SETTING) +
                    "\n        "
                )
              ]),
              _c("div", { staticClass: "setting_unit_item" }, [
                _c("p", { staticClass: "setting_unit_label" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.labelsProperties.RECRUITING_MEDIUM) +
                      "\n          "
                  )
                ]),
                _c("div", { staticClass: "setting_unit_form" }, [
                  _c("div", { staticClass: "setting_form_select_wrapper" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.displaySetting.inHouseHP,
                            expression: "displaySetting.inHouseHP"
                          }
                        ],
                        staticClass: "setting_form_select",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.displaySetting,
                              "inHouseHP",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(
                        _vm.masterMedia.filter(function(media) {
                          return media && media.show
                        }),
                        function(media, index) {
                          return _c("option", {
                            key: index,
                            domProps: {
                              value: media.choiceId,
                              textContent: _vm._s(
                                media.choiceDisplayName
                                  ? media.choiceDisplayName
                                  : media.choiceName
                              )
                            }
                          })
                        }
                      ),
                      0
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "setting_unit_item" }, [
                _c("p", { staticClass: "setting_unit_label" }, [
                  _vm._v(_vm._s(_vm.labelsProperties.PRINT_BUTTON))
                ]),
                _c("div", { staticClass: "setting_unit_form" }, [
                  _c("label", { staticClass: "setting_form_radio_label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.displaySetting.print,
                          expression: "displaySetting.print"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        value: "true",
                        id: "is_print_0",
                        checked: "checked"
                      },
                      domProps: {
                        checked: _vm._q(_vm.displaySetting.print, "true")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.displaySetting, "print", "true")
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "setting_form_radio_text",
                        attrs: { for: "is_print_0" }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.labelsProperties.DISPLAY) +
                            "\n              "
                        )
                      ]
                    )
                  ]),
                  _c("label", { staticClass: "setting_form_radio_label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.displaySetting.print,
                          expression: "displaySetting.print"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        value: "false",
                        id: "is_print_1"
                      },
                      domProps: {
                        checked: _vm._q(_vm.displaySetting.print, "false")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.displaySetting, "print", "false")
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "setting_form_radio_text",
                        attrs: { for: "is_print_1" }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.labelsProperties.NOT_DISPLAY) +
                            "\n              "
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }